export interface TransformedChartData {
  date: string;
  month: number;
  year: number;
  quarter?: number;
  actualPipeline: number;
  forecastedPipeline: number;
  actualDeals: number;
  forecastedDeals: number;
  isCurrent: boolean;
  periodEndDate?: string;
}

export enum PipelineDataType {
  PAST = "past",
  FORECAST = "forecast"
}

export enum PipelineDimension {
  MONTH = "month",
  QUARTER = "quarter"
}

export enum PipelinePeriod {
  MONTHLY = "monthly",
  QUARTERLY = "quarterly"
}

export enum PipelineMetric {
  VALUE = "value",
  DEALS = "deals"
}

export enum PaginationDirection {
  NEXT = "next",
  PREV = "prev"
}

export interface PipelineOverTimeDataPoint {
  month: number;
  year: number;
  pipeline: {
    value: number;
    dealsCount: number;
  };
  dataType?: PipelineDataType;
  periodEndDate?: string;
}

export interface PipelineOverTimeData {
  pipelineOverTime: {
    dataPoints: PipelineOverTimeDataPoint[];
    snapshotDate: string;
    totalDeals: number;
    totalValue: number;
    period: PipelinePeriod;
  };
}

export interface PipelineValueOverTimeDimensionData {
  value: number;
  dealCount: number;
  dataType: PipelineDataType;
  periodEndDate: string;
}

export interface PipelineValueOverTimeResponse {
  dimension: PipelineDimension;
  currentPage: number;
  pageSize: number;
  totalPages: number;
  prevPages: number;
  nextPages: number;
  breakdownBy: string | null;
  byDimension: {
    [key: string]: {
      all: PipelineValueOverTimeDimensionData;
    };
  };
}
